var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "50px",
    height: "50px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#fa5252",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.12,5.12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41,2c-3.85415,0 -7,3.14585 -7,7c0,1.84299 0.72436,3.51894 1.89648,4.77148l-8.37109,10.22852h-11.60547c-0.48917,-3.38246 -3.40609,-6 -6.91992,-6c-3.85415,0 -7,3.14585 -7,7c0,3.85415 3.14585,7 7,7c3.51383,0 6.43075,-2.61754 6.91992,-6h11.58203l8.0332,10.64063c-0.95846,1.19801 -1.53516,2.71263 -1.53516,4.35938c0,3.85415 3.14585,7 7,7c3.85415,0 7,-3.14585 7,-7c0,-3.85415 -3.14585,-7 -7,-7c-1.48475,0 -2.86093,0.47126 -3.99609,1.26563l-7.73242,-10.24023l8.18359,-10.00391c1.04185,0.61662 2.25132,0.97852 3.54492,0.97852c3.85415,0 7,-3.14585 7,-7c0,-3.85415 -3.14585,-7 -7,-7zM41,4c2.77327,0 5,2.22673 5,5c0,2.77327 -2.22673,5 -5,5c-2.77327,0 -5,-2.22673 -5,-5c0,-2.77327 2.22673,-5 5,-5zM9,20c2.77327,0 5,2.22673 5,5c0,2.77327 -2.22673,5 -5,5c-2.77327,0 -5,-2.22673 -5,-5c0,-2.77327 2.22673,-5 5,-5zM41,36c2.77327,0 5,2.22673 5,5c0,2.77327 -2.22673,5 -5,5c-2.77327,0 -5,-2.22673 -5,-5c0,-2.77327 2.22673,-5 5,-5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.6d941fc0c3cff96d49bfa2fdd86d8115.svg";
export { ForwardRef as ReactComponent };